import React, { useContext } from 'react';
import uniq from 'lodash/uniq';
import { FormatCarName } from '../../../../utils/Helpers/Format';
import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import Select from '../../../../components/shared/InputElements/Select';
import useSelectedVehicle from '../../../../hooks/useSelectedVehicle';
import { NEW_CONDITION_ID } from '../../../constants/vehicleConditions';
import { useIntl } from 'react-intl';

const sortEvs = (a, b) => {
  return (
    FormatCarName(a).localeCompare(FormatCarName(b)) ||
    b.model_year - a.model_year
  );
};

const SelectRateComparisonVehicle = ({
  electricVehicles,
  selectedVehicle: givenSelectedVehicle,
  vehicleConditionType = NEW_CONDITION_ID,
}) => {
  const intl = useIntl();

  const userPrefs = useContext(UserPrefsContext);
  const contextKey =
    vehicleConditionType === NEW_CONDITION_ID
      ? 'vehicleIdForRateComparison'
      : 'usedVehicleIdForRateComparison';
  const fallbackSelectedVehicle = useSelectedVehicle(
    electricVehicles,
    userPrefs.get(contextKey)
  );

  const selectedVehicle = givenSelectedVehicle || fallbackSelectedVehicle;

  return (
    <>
      <Select
        id={`home-charging-advisor-vehicle-make-${contextKey}`}
        value={selectedVehicle.make}
        optionNames={uniq(electricVehicles.map((ev) => ev.make)).sort()}
        optionValues={uniq(electricVehicles.map((ev) => ev.make)).sort()}
        handler={(e) => {
          const newVehicle = electricVehicles.find(
            (ev) => ev.make === e.target.value
          );
          userPrefs.set({
            [contextKey]: newVehicle.electric_vehicle_id,
          });
        }}
        label={intl.formatMessage({
          id: 'hcaCarMake',
          defaultMessage: 'EV make considered',
          description: 'EV make considered',
        })}
      />

      <Select
        id={`home-charging-advisor-vehicle-make-${contextKey}`}
        value={selectedVehicle.electric_vehicle_id}
        optionNames={electricVehicles
          .sort(sortEvs)
          .filter((ev) => ev.make === selectedVehicle.make)
          .map(
            (ev) =>
              `${ev.model_year} ${FormatCarName(ev)
                .split(' ')
                .slice(1)
                .join(' ')}`
          )}
        optionValues={electricVehicles
          .sort(sortEvs)
          .filter((ev) => ev.make === selectedVehicle.make)
          .map((ev) => ev.electric_vehicle_id)}
        handler={(e) => {
          const newVehicle = electricVehicles.find(
            (ev) => ev.electric_vehicle_id === parseInt(e.target.value, 10)
          );
          userPrefs.set({
            [contextKey]: newVehicle.electric_vehicle_id,
          });
        }}
        label={intl.formatMessage({
          id: 'hcaCarModel',
          defaultMessage: 'EV model considered',
          description: 'EV model considered',
        })}
      />
    </>
  );
};

export default SelectRateComparisonVehicle;
